import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";

import { useCamkitEnabled } from "./useCamkitEnabled";

export const useShouldShowWebApis = (): ApolloResult<{ data: boolean }> => {
    const { configs, loading: featureGatesLoading } = useFeatureGates();
    const { data: isCamkitEnabled, loading: camkitEnabledLoading } = useCamkitEnabled();

    return {
        data: isCamkitEnabled || configs[CofConfigId.MyLensesUiWebApis].enabled,
        loading: featureGatesLoading || camkitEnabledLoading,
    };
};
